import { Button, Flex, Menu, Burger } from "@mantine/core";
import { useTranslation } from "react-i18next";
import EkteAiLogo from "./../../../../assets/EkteAILogo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";

import style from "./navbar.module.css";

const getLandingPageUrl = () => {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "https://ekte.ai";
    }
    return `https://${hostname.replace(/^(app|www)\./, "")}`;
};

const Navbar = () => {
    const { t } = useTranslation(["landing-page"]);
    const location = useLocation();
    const currentPath = location.pathname;

    const navigate = useNavigate();

    const [opened, { toggle }] = useDisclosure(false);

    const landingPageUrl = getLandingPageUrl();

    const isActive = (path) => {
        return currentPath === path ? style.active : "";
    };

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <Flex w={"100%"} justify={"space-between"} align={"center"}>
                    <a href={`${landingPageUrl}/`}>
                        <Flex align={"center"} columnGap={"0.75rem"}>
                            <img className={style.logo} src={EkteAiLogo} alt=""></img>

                            <span className={style.brand}>{t("navbar.brand")}</span>
                        </Flex>
                    </a>

                    <Flex className={style.desktopMenu} columnGap={"0rem"} align={"center"}>
                        <a href={`${landingPageUrl}/`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.home")}</span>
                        </a>
                        <a href={`${landingPageUrl}/precision`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.precision")}</span>
                        </a>
                        <a href={`${landingPageUrl}/privacy`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.privacy")}</span>
                        </a>
                        <a href={`${landingPageUrl}/pricing`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.pricing")}</span>
                        </a>
                        <a href={`${landingPageUrl}/about-us`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.about_us")}</span>
                        </a>
                        <a href={`${landingPageUrl}/contact-us`} className={style.headerLink}>
                            <span className={style.header}>{t("navbar.contact_us")}</span>
                        </a>
                        <Button onClick={() => navigate("/sign-in")} radius={"xl"} ml={"1rem"} variant="outline" color="dark">
                            {t("navbar.login")}
                        </Button>
                    </Flex>

                    <Menu className={style.mobileMenu} opened={opened} onChange={toggle} position="bottom-end" shadow="md">
                        <Menu.Target>
                            <Burger pt={"1rem"} opened={opened} onClick={toggle} aria-label="Toggle navigation" />
                        </Menu.Target>

                        <Menu.Dropdown>
                            <a href={`${landingPageUrl}/`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.home")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <a href={`${landingPageUrl}/precision`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.precision")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <a href={`${landingPageUrl}/privacy`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.privacy")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <a href={`${landingPageUrl}/pricing`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.pricing")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <a href={`${landingPageUrl}/about-us`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.about_us")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <a href={`${landingPageUrl}/contact-us`}>
                                <Menu.Item>
                                    <span className={style.header}>{t("navbar.contact_us")}</span>
                                </Menu.Item>
                            </a>
                            <Menu.Divider my={0} />

                            <Link to={"/sign-in"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/sign-in")}`}>{t("navbar.login")}</span>
                                </Menu.Item>
                            </Link>

                            <Link to={"/sign-up"}>
                                <Menu.Item className={style.headerWhiteBg}>
                                    <span className={`${style.headerWhite} ${isActive("/sign-up")}`}>{t("navbar.sign_up")}</span>
                                </Menu.Item>
                            </Link>
                        </Menu.Dropdown>
                    </Menu>
                </Flex>
            </div>
        </div>
    );
};

export default Navbar;
